import * as types from "./historico.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  showHistorico: false,
  historicos: [],
  Origem: 0 // 0 - Solicitante / 1 - Prefeitura
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.ADD_HISTORICO:
      return state.merge({ historicos: [...state.historicos, payload] });
    case types.SET_HISTORICO:
      return state.merge({ historicos: payload });
    case types.DELETE_HISTORICO:
      return state.merge({
        historicos: state.historicos.filter(
          x => state.historicos.indexOf(x) != payload
        )
      });
    case types.MODAL_HISTORICO_CLOSE:
      return state.merge({ showHistorico: false });
    case types.MODAL_HISTORICO_OPEN:
      return state.merge({ showHistorico: true });
    default:
      return state;
  }
};

store.registerDynamicModule("historico", reduce);
